export const countries = {
    ru: {
        name: "Россия",
        mask: /^[АВЕКМНОРСТУХ]\d{3}[АВЕКМНОРСТУХ]{2}\d{2,3}$/,
        maxLength: 6,
        regions:[],
    },
    en: {name: "США", mask: /^[A-Z]{3}\d{3}$/, maxLength: 6},
    de: {name: "Германия", mask: /^[A-Z]{1,3}-[A-Z]{1,2}\d{1,4}$/, maxLength: 6},
    es: {
        name: "Испания",
        mask: /^\d{4}[BCDFGHJKLMNPRSTVWXYZ]{3}$/,
        maxLength: 7
    }
};